// Unpublished Work © 2026 Deere & Company.

import * as actions from '../../action-list';
import {DigitalUserResults} from '../../state/struct/digital-user-search/results/digital-user-result';
import {DigitalUserSearch} from '../../state/struct/digital-user-search/digital-user-search';

const setResults = (state, action) => DigitalUserResults.update(state, {
    $set: action.results
});

const resetResults = () => [];

export const results = (state = new DigitalUserSearch({}).results, action = {}) => {
    const actionHandlers = {
        [actions.SET_DIGITAL_USER_SEARCH_RESULTS]: setResults,
        [actions.RESET_DIGITAL_USER_SEARCH]: resetResults
    };
    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
};
